import _ from 'lodash';
import React from 'react';

import { Table } from 'iron-forge-react-modules';
import { activityTemplates } from 'modules';

import { ImportOrdersModal } from '../../../modules';
import * as dataService from './dataService';
import * as types from './types';



const TableComponent = Table.genTableComponent<types.IColumnId>();



export const ThirdPartyLogisticsActivity: React.FC = () => {
  const tuple = dataService.useQuery();
  const [selectedStoreId, setSelectedStoreId] = React.useState('');



  function handleCancel() {
    setSelectedStoreId('');
  }

  function handleAccept() {
    setSelectedStoreId('');
  }

  function handleClickRowPopoverOption(storeId: string, optionId: string) {
    if (optionId === 'importOrders') {
      setSelectedStoreId(storeId);
    }
  }



  const rows = React.useMemo(
    (): types.IRow[] => {
      return _.map(tuple.data.stores, (store): types.IRow => ({
        id: store.id,
        columnId2Value: {
          orderPrefix: {
            type: 'string',
            label: store.orderPrefix
          },
          storeName: {
            type: 'string',
            label: store.name
          }
        },
        popoverOptions: [
          {
            id: 'importOrders',
            label: "Import Orders"
          }
        ]
      }));
    },
    [
      tuple.data.stores
    ]
  );



  return (
    <>
      <activityTemplates.AdminActivityTemplate.FC>
        <TableComponent
          rows={rows}
          columns={[
            {
              id: 'orderPrefix',
              label: "Order Prefix"
            },
            {
              id: 'storeName',
              label: "Store Name"
            }
          ]}
          onClickRowPopoverOption={handleClickRowPopoverOption} />

      </activityTemplates.AdminActivityTemplate.FC>

      {selectedStoreId && (
        <ImportOrdersModal.FC
          storeId={selectedStoreId}
          onCancel={handleCancel}
          onAccept={handleAccept} />
      )}
    </>
  );
};
